import cn from 'classnames'
import { ComponentProps } from 'react'
import { useRefinementsConfig } from '../hooks/useRefinementsConfig'
import { RefinementWrapper } from './RefinementWrapper'
import { RefinementsMenuItem } from './RefinementsMenuItem'
import { RefinementsMenuRange } from './RefinementsMenuRange'

type RefinementsMenuProps = ComponentProps<'div'>

export function RefinementsMenu(props: RefinementsMenuProps) {
  const { lists, ranges } = useRefinementsConfig()

  return (
    <div {...props} className={cn('flex flex-wrap gap-4', props.className)}>
      {lists.map((refinement) => (
        <RefinementWrapper
          key={refinement.attribute}
          refinement={refinement}
          Component={RefinementsMenuItem}
        />
      ))}
      {ranges.map((refinement) => (
        <RefinementWrapper
          key={refinement.attribute}
          refinement={refinement}
          Component={RefinementsMenuRange}
        />
      ))}
    </div>
  )
}
